module.exports = __webpack_public_path__ + "img/eye.c074df52.svg";